export default "__VITE_ASSET__B4BCA4bm__"